module.exports = __webpack_public_path__ + "img/thumb-nikon@2x.c95fdcd9.png";